export default function getResource(label, vars = []) {
    const resources = {
        search: 'Search',
        searchStore: 'Search this store',
        searchLocation: 'Search this location',
        cancel: 'Cancel',
        previousSearches: 'Previous Searches',
        clearInputAriaLabel: 'clear search input text',
        trendingCategories: 'Trending Categories',
        searchSuggestions: 'Search Suggestions',
        productSuggestions: 'Product Suggestions',
        continueBrowsing: 'Continue Browsing',
        buyItAgain: 'Buy It Again',
        purchased: 'Purchased'
    };

    return resources[label];
}
